import { useMutation } from '@tanstack/react-query';

type JobSourceDeleteRequest = {
  id: number;
};

export default function useDeleteJobSource() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async ({ id }: JobSourceDeleteRequest): Promise<void> => {
      const response = await fetch(`/agent/api/job_sources/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete job sources');
      }
    },
  });
}
